import AnalyticsController from "@/modules/analytics/controllers/AnalyticsController";

export default function AnalyticsPage() {
  return <AnalyticsController />;
}
